import axiosInstance from "../../config/axiosInstance";

const userOperationRequest = async () => {
    const response = await axiosInstance.dillApi().get("/admin/users");
    return response;

};

export default userOperationRequest;
